export const removeOverflowOnDropdownClose = (visible: boolean) => {
  if (!visible) {
    document.body.style.removeProperty("overflow");
  }
};
